/**
 * Normalises a URL form value so that "no URL" always reaches the backend as null.
 *
 * The column used to carry two spellings for the same absence — the empty string and NULL —
 * because the dialogs wrote '' whenever a field was cleared. Every reader then had to
 * normalise them for itself. Three of the four write paths that can put a URL on a project
 * go through here, so an emptied field cannot come out as '' on one path and null on another.
 * The fourth is a literal in the project factory and needs no coercion.
 *
 * A real value is passed through untouched, surrounding whitespace included: trimming a URL
 * someone actually typed is a different decision and not this helper's to make.
 */
export function coerceUrlToNullIfBlank(value: string | null | undefined): string | null {
    if (value === null || value === undefined || value.trim() === '') {
        return null;
    }

    return value;
}
